export default "__VITE_ASSET__07ad7383__"